import { fetch } from '../../utils';
import Backend from '../../backend';
import { tracking } from '../../utils/tracking';

//TO UPDATE THE TODOs OF ADVISER
export const updateAdviserTemplate = data => {
  return fetch(Backend.methodUrl('adviserTemplate'), {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(res => {
      return res.json();
    })
    .then(result => {
      // Tracking
      tracking('Template Updated');
      return result;
    })
    .catch(error => {
      throw error;
    });
};

//TO ADD A TODO
export const addAdviserTemplate = data => {
  return fetch(Backend.methodUrl('adviserTemplate'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(res => {
      return res.json();
    })
    .then(result => {
      // Tracking
      tracking('Template Added');
      return result;
    })
    .catch(error => {
      throw error;
    });
};

//DELETE A TODO
export const deleteAdviserTemplate = data => {
  return fetch(Backend.methodUrl('adviserTemplate'), {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(res => {
      return res.json();
    })
    .then(result => {
      // Tracking
      tracking('Template Deleted');
      return result;
    })
    .catch(error => {
      throw error;
    });
};

//DELETE ALL COMPLETED TEMPLATE
export const deleteAllTemplate = () => {
  return fetch(Backend.methodUrl('adviserTemplate/all'), {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then(res => {
      return res.json();
    })
    .then(result => {
      // Tracking
      tracking('Template Deleted');
      return result;
    })
    .catch(error => {
      throw error;
    });
};
